import { create } from 'zustand';

export type Route = {
  ukPort: string;
  nonUkPort: string;
  carrierName: string;
};

type UseRoutesAndPortsState = {
  routes: Route[];
  ports: Map<string, string>;
};

export const useRoutesAndPortsState = create<UseRoutesAndPortsState>(() => ({
  ports: new Map<string, string>(),
  routes: [],
}));
